/* eslint-disable max-len */
import React, { useRef, useState,useEffect } from "react";
// import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import Debounce from "../../../CommonMethods/Debounce";
import { useCallback } from "react";
import { useDispatch ,useSelector} from "react-redux";
import { setSubDivCurIndex,toggleSubDivRowSelection,selectAllSubDivRows,searchSubDivReducer ,fillEmptySubDivArray, pushToSubDivArray, searchSubDivValSetter, storeDataFromSearch} from "../subdivisionSlice";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useGetSubDivQuery, useLazyGetSubDivQuery } from "../../../features/organizationUserSlice";

export default function DropdownWithSearchForSubDiv({
    label,
    id,
    index,
    placeholder,
    disabled,
    emptyField,
    value,
    isBlack,
    selectedOrganizationName,
    subDivisionDataLoading,
    edit,
    editData,
    setFilterValues,
    items,
    setItems,
    isOrgOpen,
    isOpen,
    setisOpen
    
 
}
) {
    const ref = useRef()
    const location=useLocation()
    const dispatch=useDispatch()
    const [searchLagLoading,setSearchLagLoading]=useState(false)
    const selectedUsers=useSelector(state=>state?.subdivSelect?.subdivData)
    const curIndex=useSelector(state=>state?.subdivSelect?.subdivData?.curIndex)
    const orgId=useSelector(state=>state?.subdivSelect?.subdivData?.orgId)
    const checkedArr= useSelector(state=>state?.subdivSelect?.subdivData?.checkedArr)
    const searchVal=useSelector(state=>state?.subdivSelect?.subdivData?.searchVal)
    const searchData=useSelector(state=>state?.subdivSelect?.subdivData?.data)
    const [displayEmptyMsg,setDisplayEmptyMsg] = useState('')
    const [suggestions,setSuggestions] = useState('')
    const [queryParams,setQueryParams] = useState(`dropdown=true&filter=true`)
    const [skip,setSkip]=useState(true)
    let {data,isFetching,isLoading,status}=useGetSubDivQuery(suggestions?.trim()===''?`${queryParams}&organization_id=${selectedOrganizationName?.[curIndex]?.organization_id}`:queryParams,{skip:(skip||selectedOrganizationName?.[curIndex]?.organization_id===undefined||selectedOrganizationName?.[curIndex]?.organization_id===''||(queryParams==='dropdown=true&filter=true'&&suggestions.trim()!=='')),refetchOnMountOrArgChange: true})
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null);
    const [searchParams,setSearchParams]=useSearchParams()
    const filtervals=useSelector(state=>state?.systemConfigData?.filterState)

    function renameKeyInArray(array, oldKey, newKey) {
        return array.map(obj => {
            if (obj.hasOwnProperty(oldKey)) {
                return { ...obj, [newKey]: obj[oldKey], [oldKey]: undefined };
            }
            return obj;
        });
    }
   
    function handleIsCheckedAll(event){
        
        dispatch(selectAllSubDivRows([event.target.checked,searchVal!==""?searchData:checkedArr[curIndex],searchVal!==''&&"search"]))
        
    }

    const handleDropdownOpen=()=>{
        if(edit!==undefined&&checkedArr[index][0]?.isEdit===true){
            setSkip(false)
            

        }
        if(searchParams.get('subdivision_ids')!==null&&checkedArr[0][0]?.isEdit===true){
            setSkip(false)
            

        }
        setDisplayEmptyMsg('')
        dispatch(setSubDivCurIndex([index,selectedOrganizationName?.[index]?.organization_id]))
        
        index===curIndex?setisOpen(!isOpen):!isOpen?setisOpen(true):''
       
    }
   
    
    const handleChange=(val,cur,id)=>{
        
        if(orgId!==undefined){
            
            if(val.trim()!==''){
                setQueryParams(`search=${encodeURIComponent(val.trim())}&dropdown=true&filter=true&organization_id=${id}`)
               
            }
            else{
                setQueryParams(`dropdown=true&filter=true`)
            }
            dispatch(searchSubDivValSetter([val.trim()]))
        }
      
    }
   
    const optimizedFn = useCallback(
        
        Debounce((value,cur,orgid) => {handleChange(value,cur,orgid)}),
        []
    );
    

    const calculateDropdownPosition = (emptyStr) => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window?.innerHeight - buttonRect?.bottom-40;
        //40px
        const dropdownHeight =dropdownRef?.current?.clientHeight;
        // if (spaceBelow < dropdownHeight) {
        //     let dataonDisplay=(searchVal===""||emptyStr!==undefined)?checkedArr[curIndex]?.map((obj)=>obj.isChecked===true):data?.data
        //     dropdownRef.current.style.top = `${dataonDisplay?.length>=3?'-190px':dataonDisplay?.length===2?'-163px':(dataonDisplay?.length===1)?'-125px':searchVal!==""?'-85px':'-164px'}`
            
        // } else {
        //     dropdownRef.current.style.top = '105%';
        // }
    };
   
    useEffect(() => {
        optimizedFn('',curIndex,orgId)
        setSuggestions('')
        dispatch(searchSubDivValSetter(['']))
        window.addEventListener('resize', calculateDropdownPosition);
        calculateDropdownPosition(); // Initial position calculation
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);

    useEffect(()=>{
       
        data?.data?.length!==0&&!isFetching&&setDisplayEmptyMsg('') 
        if(suggestions!==''){
            calculateDropdownPosition()

            isFetching&&setSearchLagLoading(true)
            //dropdownRef.current.style.top ='-148px'
            setSkip(false)
        }
        else{
            setDisplayEmptyMsg('')
            setSearchLagLoading(false)
            calculateDropdownPosition('empty')
            checkedArr[curIndex]?.length!==undefined && dispatch(searchSubDivReducer([checkedArr[curIndex],curIndex]))
            setSkip(true)
        }      
        
    },[suggestions])
    
    useEffect(()=>{
     
        if(data?.data!==undefined &&edit!==undefined &&checkedArr?.[curIndex]?.[0]?.isEdit===true){
         
            dispatch(pushToSubDivArray([data?.data,curIndex,editData?.organizations_and_subdivisions?.filter((item)=>item?.organization_id===selectedOrganizationName?.[curIndex]?.organization_id)?.map((org)=>org.subdivision_id)]))

        }
        if(data?.data!==undefined &&searchParams.get("subdivision_ids")!==null &&checkedArr[0][0]?.isEdit===true){
            dispatch(pushToSubDivArray(['fromObserverFilter',data?.data,curIndex,filtervals?.subdivision_ids]))

        }
        
        
    },[data])

    useEffect(()=>{
        if(data?.data!==undefined && !isFetching&&!isLoading){
            dispatch(storeDataFromSearch([data?.data]))
            calculateDropdownPosition()
            const timeoutId = setTimeout(()=>{setSearchLagLoading(false)},2000)
            if(data?.data?.length===0 &&suggestions!=='')  {
                setDisplayEmptyMsg('No results found.')
                
                return     
            } 
            setDisplayEmptyMsg('')   
            suggestions!==''&&dispatch(searchSubDivReducer([renameKeyInArray(data?.data,'subdivision_id','id'),curIndex]))
            calculateDropdownPosition()
            // if(!isFetching){
            //     const timeoutId = setTimeout(()=>{setSearchLagLoading(false)},2000)
            // }
            return () => {
                clearTimeout(timeoutId);
            };
        } 
    },[isFetching])
    
    useEffect(()=>{
        if(setFilterValues!==undefined){
            setFilterValues((prev)=>({
                ...prev,
                subdivision_ids:selectedUsers.checkedArr[0]?.filter(item => item.isChecked).map((item)=>item?.id)
            }))
        }
        

    },[selectedUsers.checkedArr])
    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button  id={"subdivision"} ref={buttonRef} onClick={() => {handleDropdownOpen()}} className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '}  rounded-lg px-3.5 py-[11px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} disabled={disabled}>
                    <p id= {id} className={`${isBlack?'text-[#52555D] ':'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen&&curIndex===index&&!isOrgOpen?"transform rotate-180" : ""}`}/>
                </button>
                <ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${!isOrgOpen&&isOpen&&index===curIndex ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input 
                                        type="text" 
                                        autoComplete={"off"}
                                        id="search-value-subdivision"
                                        placeholder="Search by ID/name"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none" 
                                        onChange={e=>{setSuggestions(e.target.value);optimizedFn(e.target.value,curIndex,orgId)}}
                                        value={suggestions}/>
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3"/>
                                </div>
                            </li>
                            {displayEmptyMsg===""&&!searchLagLoading&&!isFetching&&!subDivisionDataLoading&&!(searchVal!==""&&((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))) ?<li className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1 pr-4'>
                                <div className="relative checkbox custom-checkBoxBlue1">
                                
                                    <input type="checkbox" id='id1' data-testid={'select_all'} checked={selectedUsers.isCheckedAll[curIndex]} onChange={(event)=>handleIsCheckedAll(event,data)} className='prevent-click' />
                                    <label htmlFor='id1' className={`text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4`}>Select All</label>
                                </div>
                                <button onClick={()=>{dispatch(selectAllSubDivRows([false,checkedArr[curIndex]]))}} type='button' className={selectedUsers?.checkedArr[curIndex]?.filter((item)=>item.isChecked===true)?.length===0?'hidden':`text-xs font-semibold text-[#008586]`}>
                                    Clear All
                                </button>
                            </li>:displayEmptyMsg!==""&&!searchLagLoading&&!isFetching&&<p className="mt-2 text-center">{displayEmptyMsg}</p>}
                        </ul>
                        <ul>
                           
                            <li>
                                <ul className={`max-h-[440px] overflow-auto scrollbar_gray pr-3`}>
                                    {
                                        searchVal===""&&!isFetching&&searchLagLoading===false&&!subDivisionDataLoading?(checkedArr[curIndex]?.map((item,i)=>(
                                            <li key={i} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                                <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                
                                                    <input type="checkbox" id={i+"subdivision"} onChange={()=>dispatch(toggleSubDivRowSelection([item?.id,checkedArr[curIndex],item?.name]))} checked={selectedUsers?.checkedArr[curIndex]?.some(obj=>obj?.id===item?.id&&obj.isChecked===true)} className=' prevent-click' />
                                                    <label id={i+"subdivision_corp"} title={item?.id+"-"+item?.name} htmlFor={i+"subdivision"} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines">{item?.id} {item?.name}</label>
                                                </div>
                                            </li>
                                        ))):(searchLagLoading||(subDivisionDataLoading)||(isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<div className=' h-[35px] relative   px-4 xl rounded-lg mt-3 '>
                                            <div className={`flex justify-center items-center ${searchVal!==''?'mt-[65px]':'mt-[70px]'}`}>
                                                                       
                                                <div className={`loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  ${searchVal!==''?'mt-[-25px]':'mt-[-45px]'} spin-animation`}></div>
                                                                       
                                                                        
                                            </div>
                                        </div>:(data?.data?.map((item,i)=>(
                                            <li key={i} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                                <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                    <input type="checkbox" id={i+"searched_subdiv"} onChange={()=>{dispatch(toggleSubDivRowSelection([item?.subdivision_id,renameKeyInArray(data?.data, 'subdivision_id', 'id'),item?.sub_division_name]))}} checked={selectedUsers?.checkedArr[curIndex]?.some(obj=>obj?.id===item?.subdivision_id  && obj.isChecked===true)} className=' prevent-click' />
                                                    <label id ={i+"searched_subdivision"} title={item?.subdivision_id+"-"+item?.sub_division_name} htmlFor={i+"searched_subdiv"} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines">{item?.subdivision_id} {item?.sub_division_name}</label>
                                                </div>
                                            </li>
                                        )))
                                    }
                                </ul>
                            </li>
                        </ul>
                    </li>
                 
                </ul>           
            </div>
        </>
    )
}
